import SeedlyngLogo from '@/assets/branding/seedlyng/seedlyng-horizontal.png';

export default {
  name: 'SD171',
  allowPersonalCourses: false,
  logo: SeedlyngLogo,
  colors: {
    // Brand colors
    brand_primary: '#FF5733',
    brand_primary_hover: '#E04D2E',
    brand_primary_highlight: '#F5B1A3',
    brand_primary_mid: '#D6725C',
    brand_primary_dark: '#B83214',
    brand_secondary: '#2f6cce',
  },
};
